import { useNavigate } from 'react-router-dom'
import { motion } from 'framer-motion'
import AnimationButton from '../../atoms/AnimationButton/AnimationButton'
import Constants from '../../../app/utils/constants'
import arrowIcon from '../../../assets/images/icons/arrowicon.svg'
import colors from '../../theme/color'

const BlogCardsSection = () => {
  const navigate = useNavigate()
  const { blogPageFilterButtons, blogPageCards } = Constants

  return (
    <section className="mx-auto w-[80%] 2xl:w-[65%] py-12 md:py-16">
      
      {/* 🔥 FILTER BUTTONS ANIMATION */}
      <div className="mb-10 grid grid-cols-2 gap-4 md:grid-cols-4 md:gap-6">
        {blogPageFilterButtons.map((label, index) => (
          <motion.div
            key={label}
            initial={{ scale: 0.6, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            viewport={{ once: false, amount: 0.3 }}
            transition={{
              duration: 0.6,
              delay: index * 0,
              ease: 'easeIn',
            }}
            className="rounded-full p-px"
            style={{
              background: `linear-gradient(90.94deg, ${colors.purpleAlt} 0%, rgba(116,94,240,0.1) 50%, ${colors.purpleAlt} 100%)`,
            }}
          >
            <AnimationButton
              className="px-4! py-3! text-sm font-rajdhani font-semibold transition-all duration-300 hover:scale-105 hover:bg-purple md:px-6! md:py-4! md:text-base lg:text-lg xl:text-xl 2xl:text-2xl"
            >
              {label}
            </AnimationButton>
          </motion.div>
        ))}
      </div>

      {/* 🔥 BLOG CARDS */}
      <div className="grid grid-cols-1 gap-6 md:grid-cols-2 md:gap-8 2xl:gap-15">
        {blogPageCards.map((card, index) => {
          
          // 👉 Left / Right animation logic
          const isLeft = index % 2 === 0

          return (
            <motion.article
              key={card.slug}
              className="group overflow-hidden rounded-3xl cursor-pointer"
              
              // 🎬 Scroll Animation
              initial={{
                opacity: 0,
                x: isLeft ? -100 : 100,
              }}
              whileInView={{
                opacity: 1,
                x: 0,
              }}
              viewport={{ once: false, amount: 0.3 }}
              transition={{
                duration: 0.6,
                delay: index * 0,
                ease: 'easeIn',
              }}

              // 🔥 Hover Scale
              whileHover={{ scale: 1.04 }}
            >
              <div
                className="overflow-hidden rounded-2xl transition-colors duration-500"
                style={{ backgroundColor: colors.blogCardPanel }}
                onClick={() => navigate(`/blogdetails/${card.slug}`)}
              >
                <img
                  src={card.image}
                  alt={card.heading}
                  className="h-[220px] w-full object-cover md:h-[260px] 2xl:h-[350px] transition-transform duration-300 group-hover:scale-105"
                />

                <div className="p-4 md:p-5">
                  <div className="mb-2 flex items-center justify-start gap-3 text-sm text-gray-200 md:text-base 2xl:text-xl">
                    <h6 className="font-gilroy-medium text-gray-400">{card.category}</h6>
                    <span className="text-gray-100 mb-2">-</span>
                    <span className="font-gilroy-medium text-gray-400 2xl:text-xl">{card.date}</span>
                  </div>

                  <h3 className="mb-3 text-left font-rajdhani text-xl font-semibold text-white md:text-2xl 2xl:text-3xl">
                    {card.heading}
                  </h3>

                  <p className="mb-4 line-clamp-3 text-left font-gilroy-medium text-sm leading-relaxed text-gray-400 md:text-base 2xl:text-xl">
                    {card.description}
                  </p>

                  <div className="mb-3 h-px w-full bg-purple/70" />

                  <button
                    type="button"
                    className="group flex items-center gap-2 text-left font-gilroy-medium text-sm text-white/90 md:text-sm 2xl:text-lg"
                  >
                    <span>More Detail</span>

                    <motion.span
  aria-hidden
  className="h-5 w-5"
  style={{
    backgroundColor: colors.purple,
    WebkitMaskImage: `url(${arrowIcon})`,
    maskImage: `url(${arrowIcon})`,
    WebkitMaskRepeat: 'no-repeat',
    maskRepeat: 'no-repeat',
    WebkitMaskPosition: 'center',
    maskPosition: 'center',
    WebkitMaskSize: 'contain',
    maskSize: 'contain',
  }}
  animate={{ x: [0, 6, 0] }}
  transition={{
    duration: 1,
    repeat: Infinity,
    ease: 'easeInOut',
  }}
/>
                  </button>
                </div>
              </div>
            </motion.article>
          )
        })}
      </div>
    </section>
  )
}

export default BlogCardsSection